import React from 'react';
// import HeatMap from '../../../_common/D3Chart/HeatMap';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
import { Box, Typography, useMediaQuery } from '@mui/material';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { dataConstants } from '../../../../constants';
import HeatMap from './HeatMap';

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#fff',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 377,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
    padding: 0, borderRadius: '8px', boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)',
  },
}));

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? 'rgb(10, 25, 41)' : '#fff',
  ...theme.typography.body2,
  height: '100%',
  color: theme.palette.text.secondary,
  boxShadow: theme.palette.mode === 'dark' ? 0 : '0 0.5px 1px rgb(255 255 255 / 20%), 0 2px 3px rgb(255 255 255 / 10%)',
  border: theme.palette.mode === 'dark' ? '1px solid rgb(19, 47, 76)' : '1px solid #eae9ee',
  borderRadius: useMediaQuery(theme.breakpoints.down('md')) ? '0 0 7px 7px' : '7px',
  '& .Item-Head': {
    background: '#fbfbfc',
    borderBottom: '1px solid #eae9ee',
    marginBottom: 0,
    padding: theme.spacing(1.5, 2, 1.5, 2),
    borderRadius: '7px 7px 0 0',
    '& a': {
      textDecoration: 'none',
    },
    '& .option-title': {
      fontWeight: 600,
      color: '#13113c',
      fontSize: '.875rem',
    }
  },
  '& .Item-Body': {
    padding: theme.spacing(0, 0, 0, 0),
  }
}));


const { FUNDS_SECTIONS } = dataConstants;

const FundHeatMap = ({ data, stockTickers, name, heatmapSettings }) => {
  const holdings = data ? data.find(d => d.section_code === FUNDS_SECTIONS.FUND_HOLDINGS) : undefined;
  let holdingsTbl = holdings && holdings.tabData && holdings.tabData.length > 0 ? holdings.tabData : undefined;
  holdingsTbl = holdingsTbl && holdingsTbl.length > 0 ? holdingsTbl.filter(type => type.putCall != 'PUT' && type.putCall != 'CALL').slice(0, 50) : null;

  return (
    <>
      {holdingsTbl && holdingsTbl.length > 0 ?
        <Item component="div" className="col-md-12" sx={{ mt: 1.2 }}>
          <Box component="div" className="row sum-r recent-news">
            <Box component="div" className="s-card">
              <Box
                className="Item-Head"
                sx={{ mb: 0.5, px: 0.5, background: '#fbfbfc' }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Typography className="option-title" component="h4" sx={{ textAlign: 'left', }} >{`${name} Holdings Map`}</Typography>
                  <LightTooltip title={<React.Fragment>
                    <Typography variant="body2" component="div" sx={{ fontSize: '.75rem !important', textAlign: 'left', background: "#fbfbfc", borderTop: 1, borderColor: '#eae9ee', borderRadius: "7px", px: 2, py: 1, color: '#333' }} >
                      <Box mb={1} mt={1.2}>
                        <Typography variant="body2" component="p">
                          <strong>Color:</strong> Indicates the percentage change from the previous quarter. The spectrum ranges from solid green (positive change) to solid red (negative change), with grey representing no change.
                        </Typography>
                      </Box>
                      <Box mb={1}>
                        <Typography variant="body2" component="p">
                          <strong>Size:</strong> Reflects the investment's proportion relative to the overall portfolio size.
                        </Typography>
                      </Box>
                      <Box mb={1}>
                        <Typography variant="body2" component="p">
                          <strong>New Positions:</strong> Always displayed in green.
                        </Typography>
                      </Box>
                      <Box mt={2}>
                        <Typography variant="body2" component="p">
                          A large green box signifies a substantial addition to the portfolio, indicating a significant investment in that stock. Conversely, a large red box denotes a reduction in holdings, yet it remains a considerable part of the portfolio.
                        </Typography>
                      </Box>
                    </Typography>
                  </React.Fragment>}>
                    <Box component={HelpOutlineRoundedIcon} sx={{ fontSize: "1rem", ml: 1, cursor: 'pointer' }} />
                  </LightTooltip>
                </Box>
                <Typography variant="body2" component="div" sx={{ fontSize: '.75rem !important', textAlign: 'left', }} >
                  <Box mt={1}>
                    <Typography variant="body2" component="p">
                      This heatmap illustrates the top 50 positions within the fund's portfolio.
                    </Typography>
                  </Box>
                </Typography>
              </Box>
            </Box>
            <Box className="Item-Body">
              <HeatMap data={holdingsTbl} stockTickers={stockTickers} heatmapSettings={heatmapSettings} />
            </Box>
          </Box>
        </Item> : null}
    </>
  );
};

export default FundHeatMap;
